// Maps each SamModule to the tool names the agent may call on that module.
// Kept in sync with api-service/app/services/llm/page_tools.py PAGE_TOOLS.
// Sent with every agent.context_update so the backend can do turn-time tool resolution.
import type { SamModule } from '@/components/SAM/samActionTypes';

export const MODULE_TOOLS: Partial<Record<SamModule, string[]>> = {
  tasks: [
    'get_tasks', 'create_task', 'open_task', 'update_task', 'update_task_status',
    'add_task_comment', 'resolve_assignee', 'claim_task', 'set_reminder', 'switch_task_tab',
    'follow_task', 'unfollow_task',
  ],
  my_todos: ['get_my_todos', 'open_task', 'switch_task_tab', 'open_meeting', 'switch_meeting_tab'],
  users: ['get_users', 'update_user'],
  roles: ['get_roles'],
  meetings: [
    'get_meetings', 'create_meeting', 'reschedule_meeting', 'cancel_meeting', 'open_meeting',
    'update_meeting_status', 'switch_meeting_tab', 'set_meeting_reminder', 'add_meeting_note',
    'add_meeting_participant', 'remove_meeting_participant',
  ],
  calendar: ['open_calendar'],
  notifications: ['get_notifications', 'list_pending_approvals'],
  properties: ['search_engagement', 'create_engagement', 'update_engagement', 'get_engagement'],
  workflow: [
    'search_engagement', 'get_engagement', 'create_engagement', 'get_engagement_workflow_state',
    'list_available_transitions', 'execute_workflow_transition', 'list_pending_approvals',
    'decide_workflow_approval',
  ],
  engagements: [
    'search_engagement', 'get_engagement', 'create_engagement', 'get_engagement_workflow_state',
    'list_available_transitions', 'execute_workflow_transition', 'list_pending_approvals',
    'decide_workflow_approval',
  ],
};
